export default "__VITE_ASSET__ff7a8307__"